module.exports = __webpack_public_path__ + "static/media/cloud-outline.c5ceb7ab.svg";